import React, { useState } from "react";
import {
  Button,
  FormFieldSet,
  showToast,
} from "../../../../../../../../components";
import {
  addRole,
  updateRole,
} from "../../../../../../../../redux/slices/setting/settingApi";
import { useDispatch, useSelector } from "react-redux";
import { getRolesStart } from "../../../../../../../../redux/slices/setting/settingsSlice";
import { trackEvent } from "../../../../../../../../utils/mixpanelService";

const AddRole = ({ onCancel, data,isBenchUser }) => {
  const [module, setModule] = useState(data?.moduleName || "");
  const [roleName, setRoleName] = useState(data?.roleName || "");
  const [roleType, setRoleType] = useState(data?.roleType || "");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth); 
  console.log(isBenchUser)
  // console.log(data)

  // const roletypes =
  //   // module === "ats"
  //   module === 1 // for all
  //     ?
  //     // [
  //     //     { label: "Research Analyst", value: 1 },
  //     //     { label: "Business Development", value: 2 },
  //     //     { label: "Recruitment", value: 3 },
  //     //     { label: "Bench Sales", value: 4 },
  //     //   ]
  //     [
  //       { label: "Admin", value: 1 },
  //       { label: "Research Analyst", value: 2 },
  //       { label: "Business Development Manager", value: 3 },
  //       { label: "Recruiter", value: 4 },
  //       { label: "Employee", value: 5 },
  //       { label: "Human Resources", value: 6 },
  //       { label: "Finance", value: 7 },
  //       { label: "Immigration", value: 8 },
  //       { label: "Other", value: 30 }
  //     ]

  //     // : module === "workforce"
  //     : module === 2 // for ats
  //     ?
  //     // [
  //     //     { label: "Finance", value: 1 },
  //     //     { label: "HR", value: 2 },
  //     //     { label: "Recruitment", value: 3 },
  //     //     { label: "Immigration", value: 4 },
  //     //   ]
  //     [
  //       { label: "Admin", value: 1 },
  //       { label: "Research Analyst", value: 2 },
  //       { label: "Business Development Manager", value: 3 },
  //       { label: "Recruiter", value: 4 },
  //       { label: "Employee", value: 5 },
  //       { label: "Human Resources", value: 6 },
  //       { label: "Finance", value: 7 },
  //       { label: "Immigration", value: 8 },
  //       { label: "Other", value: 30 }
  //     ]
  //     : "";
  const roletypes =
    module === 1 // for All
      ? [
          { label: "Admin", value: 1 },
          { label: "Research Analyst", value: 2 },
          { label: "Business Development Manager", value: 3 },
          { label: "Recruiter", value: 4 },
          { label: "Employee", value: 5 },
          { label: "Human Resources", value: 6 },
          { label: "Finance", value: 7 },
          { label: "Immigration", value: 8 },
          { label: "Other", value: 30 },
        ]
      : module === 2 // for ATS
      ? [
          { label: "Admin", value: 1 },
          { label: "Research Analyst", value: 2 },
          { label: "Business Development Manager", value: 3 },
          { label: "Recruiter", value: 4 },
          { label: "Employee", value: 5 },
          { label: "Human Resources", value: 6 },
          { label: "Finance", value: 7 },
          { label: "Immigration", value: 8 },
          { label: "Other", value: 30 },
          { label: "Bench Recruiter", value: 9 },
        ]
      : module === 3 // for Workforce
      ? [
          { label: "Admin", value: 1 },
          { label: "Research Analyst", value: 2 },
          { label: "Business Development Manager", value: 3 },
          { label: "Recruiter", value: 4 },
          { label: "Employee", value: 5 },
          { label: "Human Resources", value: 6 },
          { label: "Finance", value: 7 },
          { label: "Immigration", value: 8 },
          { label: "Other", value: 30 },
        ]
      : module === 4 // for BenchSales
      ? [
          { label: "Admin", value: 1 },
          {label:"Manager", value:3},
          { label: "Recruiter", value: 9 },
        ]
      : "";

  const handleSave = async () => {
    if (!module || !roleName || !roleType) {
      showToast("all fields are required", "error", 2000);
      return;
    }

    try {
      setLoading(true);
      if (data) {
        const res = await updateRole({
          id: data.doc_id,
          payload: {
            $set: {
              name: roleName,
            },
          },
          coll:"Role"
        });

        if (res?.data) {
          showToast("Role updated successfully", "success", 2000);
          trackEvent({eventName:"Role_Updated",props:{
             firstName:formData?.firstName
          }})
          dispatch(
            getRolesStart({ coll: "Role", ret: "uiid name module type" })
          );
          onCancel(); // close modal
        } else {
          let errorMsg =
            res?.error?.errorResponse?.errmsg ||
            "An error occurred.";
          showToast(errorMsg, "error", 2000);
        }
      } else {
        const res = await addRole({
          coll: "Role",
          payload: {
            // module: module === "ats" ? 1 : 2, // backend expects 1/2
            module,
            name: roleName,
            type: roleType,
            addedBy: user.data.uiid,
          },
        });

        if (res?.data) {
          showToast("Role added successfully", "success", 2000);
          trackEvent({eventName:"Role_Added",props:{
             roleName:roleName
          }})
          dispatch(
            getRolesStart({
              coll: "Role",
              // ret: "uiid roleName module roleType"
              ret: "uiid name module type",
            })
          );
          onCancel(); // close modal
        } else {
          let errorMsg =
            res?.error?.errorResponse?.errmsg ||
            "An error occurred.";
          showToast(errorMsg, "error", 2000);
        }
      }
    } catch (err) {
      showToast("Error while adding role", "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-between gap-3 px-4">
      <div className="grid grid-cols-2 gap-4">
        <FormFieldSet
          type="select"
          placeholder="Select Module"
          title="Select Module"
          value={module}
          // onChange={(value) => setModule(value)}
          onChange={(value) => setModule(Number(value))}
          options={[
            // { label: "ATS", value: "ats" },
            // { label: "WorkForce", value: "workforce" },
            // { label: "All", value: 1 }, // Mahender told to comment
            { label: "ATS", value: 2 },
            { label: "WorkForce", value: 3 },
            { label: "Benchsales", value: 4 },
          ].filter((option) =>
  isBenchUser ? option.value === 4 : true
)}
          disabled={!!data}
          shadow={true}
        />
        <FormFieldSet
          title="Role name"
          placeholder="Role name"
          value={roleName}
          onChange={(value) => setRoleName(value)}
          shadow={true}
        />
        <FormFieldSet
          title="Role Type"
          placeholder="Role Type"
          type="select"
          // disabled={module ? false : true}
          disabled={!module || !!data}
          options={roletypes}
          value={roleType}
          onChange={(value) => setRoleType(value)}
          shadow={true}
        />
      </div>
      <div className="flex gap-2 mt-3 mb-10 justify-end">
        <Button
          variant="outlined"
          title={"Cancel"}
          color="black"
          onClick={() => onCancel()}
        />
        <Button title={"save"} onClick={handleSave} />
      </div>
    </div>
  );
};

export default AddRole;
